import { useState, useRef } from "react";
// route
import { useNavigate } from "react-router";
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
// models
import {
  DocumentosBEPS,
  initialValuesDocumentosBEPS,
} from "../../../../../models/Beps/documentosbeps.model";
import { openNotification } from "../../../../../utils/saveFile";
import DocumentosService from "../../../../../api/Documentos/api-documentos";
import { ObjNotificaciones } from "../../../../../config/notificaciones";
import apiNotificaciones from "../../../../../api/Notificaciones/api-notificaciones";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
import getStorageUser from "../../../../../middlewares/GetStorageUser"

export const useDocumentosConvocatoria = () => {
  // const { idConvocatoria } = useSelector((state: any) => state.convocatoria);
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const [documento, setDocumento] = useState<DocumentosBEPS>(
    initialValuesDocumentosBEPS
  );
  const [documentos, setDocumentos] = useState<Array<DocumentosBEPS>>([]);
  const [modalvisualizardocumento, setModalVisualizarDocumento] =
    useState(false);
  const [documentovisualizar, setDocumentoVisulizar] = useState("");
  const [modaleditardocumento, setModalEditarDocumento] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [documentoeditar, setDocumentoEditar] = useState<DocumentosBEPS>(initialValuesDocumentosBEPS);
  const [indexdocumento, setIndexDocumento] = useState(0);
  const fileInputRef = useRef<any>();
  const navigate = useNavigate();

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "application/pdf" ||
        e.target.files[0].type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        e.target.files[0].type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setDocumento({ ...documento, url_documento: data.data });
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF, Word y Excel",
        placement: "bottomRight",
      });
      return setDocumento({ ...documento, url_documento: "" });
    }
  };
  const agregarfila = () => {
    setDocumentos([...documentos, documento]);
    return setDocumento(initialValuesDocumentosBEPS);
  };
  const eliminarFila = async (index: number) => {
    let infoupdate = [...documentos];
    if (infoupdate[index].url_documento) {
      await DocumentosService.eliminarArchivo(infoupdate[index].url_documento);
    }
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    return setDocumentos(infoupdate);
  };
  const guardarycontinuar = async (cambiarPestaña) => {
    setLoading(true);
    const user = getStorageUser()
    await apiConvocatorias.guardarDocumentosadministrativos(
      idConvocatoria,
      documentos
    );
    await apiNotificaciones.enviarNotificacion({
      tipo_participante: 3,
      tipo_notificacion: "inscripción",
      remitente: user.documento,
      convocatoria_id: idConvocatoria,
    });
    await ObjNotificaciones.MSG_SUCCESS(
      "success",
      `Se ha guardado correctamente la convocatoria #${idConvocatoria}`
    );
    setLoading(false);
    navigate("/administrador");
    return cambiarPestaña("1");
  };
  const editarFila = () => {
    let infoupdate = [...documentos];
    infoupdate[indexdocumento] = documento;
    //console.log(infoupdate, "este es el infoupdate");
    return setDocumentos(infoupdate);
  };
  return {
    documento,
    setDocumento,
    documentos,
    setDocumentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    editarFila,
    eliminarFila,
    guardarycontinuar,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisulizar,
    modaleditardocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento,
    loading,
    setLoading,
  };
};
